module.exports = __webpack_public_path__ + "img/messaging.8521c4bd.webp";